export default "__VITE_ASSET__B7gn$3R1__"